<template>
  <div>
    <div class="title-sy"><span style="border-bottom: 1px solid rgb(124, 185, 186);">核心战略品牌</span></div>
      <el-row type="flex" justify="center" class="div-middle-all">
        <el-col :span="6" v-for="(item, idx) in imgList" :key="idx">
          <div v-if="flag == idx">
            <el-image :src="item.nsrc"
                      fit="contain"
                      class="hx-img"
                      @mouseover="handleover(idx)"
                      @mouseleave="handleleave()"
                      @click="toBrand(item.idx)"
            ></el-image>
          </div>
          <div v-else>
            <el-image :src="item.src"
                      fit="contain"
                      class="hx-img"
                      @mouseover="handleover(idx)"
                      @mouseleave="handleleave()"
            ></el-image>
          </div>
        </el-col>
      </el-row>
    <div class="div-middle-all">
      <img :src="imgHBrandSrc" style="width:85%;">
    </div>
  </div>
</template>

<script>
export default {
  name: "HBrandPlugin",
  data() {
    return {
      flag: -1,
      imgList: [
        {src: require('../assets/images/logo/01-424-424.png'), nsrc: require('../assets/images/logo/1-424-424.png'), idx: '2-1'},
        {src: require('../assets/images/logo/02-424-424-01.png'), nsrc: require('../assets/images/logo/2-424-424-01.png'), idx: '2-2'},
        {src: require('../assets/images/logo/03-424-424.png'), nsrc: require('../assets/images/logo/3-424-424.png'), idx: '2-3'},
        {src: require('../assets/images/logo/04-424-424.png'), nsrc: require('../assets/images/logo/4-424-424.png'), idx: '2-4'},
        {src: require('../assets/images/logo/05-424-424.png'), nsrc: require('../assets/images/logo/5-424-424.png'), idx: ''},
        {src: require('../assets/images/logo/06-424-424.png'), nsrc: require('../assets/images/logo/6-424-424.png'), idx: ''},
        {src: require('../assets/images/logo/07-424-424.png'), nsrc: require('../assets/images/logo/7-424-424.png'), idx: ''},
        {src: require('../assets/images/logo/08-424-424.png'), nsrc: require('../assets/images/logo/8-424-424.png'), idx: ''},
      ],
      imgHBrandSrc: require('../assets/images/pinpai-cs.jpg'),
    }
  },
  created() {
  },
  methods:{
    handleover: function(i){   //鼠标移入触发改变img的src为白色图片的路径
      this.flag = i
    },
    handleleave: function(){ //鼠标移出触发改变img的src为黑色图片的路径
      this.flag = -1
    },
    toBrand(idx) {
      if (idx) {
        this.$router.push({path: "/brand", query: {pmark: idx}})
      }
    }
  }
}
</script>

<style scoped>
.hx-img {
  padding: 0px 5px;
  width:35%;
  height:70%;
}
 .div-middle-all{
   flex-wrap: wrap;
   margin: 50px auto;
 }
</style>
